"use strict";
// Copyright © Veeam Software Group GmbH
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatetimeInputControl = void 0;
const react_1 = __importStar(require("react"));
const DatetimeInputControl_styles_1 = require("./DatetimeInputControl.styles");
const icons_1 = require("../../../../icons");
const InputControl_1 = require("../../../helpers/InputControl");
const constants_1 = require("../../helpers/constants");
exports.DatetimeInputControl = react_1.default.memo(function DatetimeInputControl(_a) {
    var { className, actions, control, error, placeholder, disabled, size, active, opened, focused, testId, onChange, readOnly, value, hasEnterKeyStopPropagation, style } = _a, rest = __rest(_a, ["className", "actions", "control", "error", "placeholder", "disabled", "size", "active", "opened", "focused", "testId", "onChange", "readOnly", "value", "hasEnterKeyStopPropagation", "style"]);
    const ref = (0, react_1.useRef)(null);
    const controlRef = (0, react_1.useMemo)(() => (control === null || control === void 0 ? void 0 : control.ref) || ref, [control === null || control === void 0 ? void 0 : control.ref]);
    const handleOnMouseEnter = (0, react_1.useCallback)((e) => {
        var _a;
        if (opened) {
            return;
        }
        (_a = control === null || control === void 0 ? void 0 : control.onMouseEnter) === null || _a === void 0 ? void 0 : _a.call(control, e);
    }, [control, opened]);
    const handleOnChange = (0, react_1.useCallback)((e) => {
        onChange === null || onChange === void 0 ? void 0 : onChange(e.target.value);
    }, [onChange]);
    const handleOnKeyDown = (0, react_1.useCallback)((e) => {
        if (e.key !== 'Escape' && e.key !== 'Enter') {
            e.stopPropagation();
        }
    }, []);
    const onActionClick = (0, react_1.useCallback)(() => {
        opened ? actions === null || actions === void 0 ? void 0 : actions.close() : actions === null || actions === void 0 ? void 0 : actions.open();
    }, [actions, opened]);
    const actionsList = (0, react_1.useMemo)(() => [
        {
            icon: react_1.default.createElement(icons_1.CalendarIcon, { disabled: disabled, error: error }),
            testId: constants_1.dataSelectorId.dateTimeCalendarControl,
            active: opened,
            onClick: onActionClick
        }
    ], [disabled, error, onActionClick, opened]);
    const isActive = (0, react_1.useMemo)(() => opened || active, [active, opened]);
    return (react_1.default.createElement(DatetimeInputControl_styles_1.StyledDatetimeInputControl, Object.assign({}, rest, { ref: controlRef, style: style, "data-selector-id": testId, hasError: error, isDisabled: disabled, size: size, rows: 1, actions: actionsList, isActive: isActive, isFocused: focused, onFocus: control === null || control === void 0 ? void 0 : control.onFocus, onBlur: control === null || control === void 0 ? void 0 : control.onBlur, onClick: control === null || control === void 0 ? void 0 : control.onClick, onMouseDown: control === null || control === void 0 ? void 0 : control.onMouseDown, onMouseUp: control === null || control === void 0 ? void 0 : control.onMouseUp, onMouseEnter: handleOnMouseEnter, onMouseLeave: control === null || control === void 0 ? void 0 : control.onMouseLeave, onKeyDown: control === null || control === void 0 ? void 0 : control.onKeyDown, onKeyUp: control === null || control === void 0 ? void 0 : control.onKeyUp, onKeyPress: control === null || control === void 0 ? void 0 : control.onKeyPress, className: className }),
        react_1.default.createElement(InputControl_1.InputControl, { tabIndex: -1, readOnly: readOnly, placeholder: placeholder, disabled: disabled, value: value, hasEnterKeyStopPropagation: hasEnterKeyStopPropagation, "data-selector-id": 'input-control', onChange: handleOnChange, onKeyDown: handleOnKeyDown })));
});
//# sourceMappingURL=DatetimeInputControl.js.map